import { graphql } from '@/gql';
import type { PaymentTierInputType } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const createPaymentTier = async (data: PaymentTierInputType) => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation CreatePaymentTier($data: PaymentTierInputType!) {
        createPaymentTier(data: $data) {
          id
          code
          service
          currency
          unit
          chargePerOrder
          chargePerUnit
          chargePerUnitForSelfOrdering
          maxCharge
          isActive
        }
      }
    `),
    variables: { data },
  });

  return response.data.createPaymentTier;
};
